[
    {
      "display": "true",
      "ui_columnname": "Event type",
      "db_columnname": "Event type",
      "datatype": "String",
      "mappingkey": "EventType",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Route Date Time",
      "db_columnname": "Route Date Time",
      "datatype": "String",
      "mappingkey": "RouteDateTime",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "OMS Order ID",
      "db_columnname": "OMS Order ID",
      "datatype": "String",
      "mappingkey": "OMSOrderID",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Order ID",
      "db_columnname": "Order ID",
      "datatype": "String",
      "mappingkey": "OrderID",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Route ID",
      "db_columnname": "Route ID",
      "datatype": "String",
      "mappingkey": "RouteId",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Symbol",
      "db_columnname": "Symbol",
      "datatype": "String",
      "mappingkey": "Symbol",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Side",
      "db_columnname": "Side",
      "datatype": "String",
      "mappingkey": "BuySellCode",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Route Qty",
      "db_columnname": "Route Qty",
      "datatype": "String",
      "mappingkey": "Quantity",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Route Price",
      "db_columnname": "Route Price",
      "datatype": "String",
      "mappingkey": "LimitPrice",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Bid Price",
      "db_columnname": "Bid Price",
      "datatype": "String",
      "mappingkey": "BidPrice",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Ask Price",
      "db_columnname": "Ask Price",
      "datatype": "String",
      "mappingkey": "AskPrice",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Ext Destination",
      "db_columnname": "Ext Destination",
      "datatype": "String",
      "mappingkey": "ExtDestination",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Position",
      "db_columnname": "Position",
      "datatype": "String",
      "mappingkey": "Position",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Price Type",
      "db_columnname": "Price Type",
      "datatype": "String",
      "mappingkey": "PriceType",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Stop Price",
      "db_columnname": "Stop Price",
      "datatype": "String",
      "mappingkey": "StopPrice",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    },
    {
      "display": "true",
      "ui_columnname": "Display Qty",
      "db_columnname": "Display Qty",
      "datatype": "String",
      "mappingkey": "DisplayQty",
      "dropdown": "NO",
      "disabled": "false",
      "value": "",
      "dropdownvalue": ""
    }
  ]